<template>
  <div>
    <div>
      <div
          class="climate-the-region"
          v-if="!dailyWeather.length">
        <p class="text-center">اطلاعاتی یافت نشد</p>
      </div>
      <div
          class="climate-the-region"
          v-else>
        <div class="climate-title text-center">
          {{
            city !== null ? `آب و هوای ${city.name}`
                : "نام شهر ثبت نشده است"
          }}
        </div>
        <div class="climate-the-region-style">
          <swiper
              :slidesPerView="3.6"
              :breakpoints="{
            '1024': {
              slidesPerView: 7,
            },
          }"
              dir="rtl"
          >
            <swiper-slide
                v-for="(item, index) in dailyWeather"
                :key="index"
                :class="{ 'today-item': isToday(item.date) }" class="p-1"
            >
              <div class="d-flex flex-column align-items-center climate-the-region-day">
                <div class="climate-text">{{ item.day }}</div>
                <div class="weather-icon">
                  <img class="img-fluid climate-image"
                       :src="`https://app.jalizan.com/weather_icons/${item.weather[0].icon}@2x.png`"/>
                </div>
                <div class="climate-text">
                  {{ Math.round(item.temp.min) }}/ {{ Math.round(item.temp.max) }}
                </div>
                <!--              <div class="d-flex align-items-center precipitation-text" v-if="item.precipitation.value !== 0">-->
                <!--                <span> بارش:</span>-->
                <!--                <span>{{item.precipitation.value}}</span>-->
                <!--              </div>-->
                <div class="d-flex align-items-center precipitation-text" v-if="item.humidity !== 0">
                  <span> رطوبت:</span>
                  <span>{{ item.humidity }}%</span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "ClimateTheRegion",
  inject: ["$axios"],
  props: {
    weather: {
      type: [Array, Object],
      default: null,
    },
    city: {
      type: Object,
    },
  },
  computed: {
    dailyWeather() {
      if (!this.weather) return [];
      if (Array.isArray(this.weather)) return this.weather;
      return Array.isArray(this.weather.daily) ? this.weather.daily : [];
    },
  },
  methods: {
    isToday(dateString) {
      const itemDate = new Date(dateString);
      const today = new Date();

      return (
          itemDate.getFullYear() === today.getFullYear() &&
          itemDate.getMonth() === today.getMonth() &&
          itemDate.getDate() === today.getDate()
      );
    }
  }
};
</script>

<style lang="scss">
@import "src/styles/modules/SoilConsulting/ClimateTheRegion";
</style>
